export const sdsToastStateServiceDIKey = "sds_toast_state_service_v1";
export const sdsToastDataClientDIKey = "sds_toast_data_client_v1";
//# sourceMappingURL=sdsToastStateServiceDiKeys.js.map